import { render, staticRenderFns } from "./myBusiness.vue?vue&type=template&id=6987c003&"
import script from "./myBusiness.vue?vue&type=script&lang=js&"
export * from "./myBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports